// extracted by mini-css-extract-plugin
module.exports = {"root":"CustomTip_root__3d94_","inputWrap":"CustomTip_inputWrap__2The2"};